import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import { FOOTER_SOCIAL_LINKS } from "@/constants/site.constants";
import FooterNewsletter from "./home/FooterNewsletter";
type IconProps = {
  size?: number;
  className?: string;
};
function GithubIcon(t0) {
  const $ = _c(4);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.56 0-.27-.01-1.16-.02-2.1-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.27-1.69-1.27-1.69-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.02 1.76 2.68 1.25 3.33.96.1-.75.4-1.25.72-1.54-2.55-.29-5.24-1.28-5.24-5.69 0-1.26.45-2.28 1.18-3.09-.12-.29-.51-1.46.11-3.05 0 0 .97-.31 3.18 1.18a11.02 11.02 0 0 1 5.78 0c2.21-1.49 3.18-1.18 3.18-1.18.62 1.59.23 2.76.11 3.05.73.81 1.18 1.83 1.18 3.09 0 4.42-2.7 5.4-5.27 5.68.41.36.78 1.07.78 2.15 0 1.55-.01 2.8-.01 3.18 0 .31.21.68.8.56C20.21 21.39 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5Z" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className || $[2] !== size) {
    t3 = <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" className={className} aria-hidden={true}>{t2}</svg>;
    $[1] = className;
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function LinkedinIcon(t0) {
  const $ = _c(4);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.03-1.85-3.03-1.85 0-2.13 1.45-2.13 2.94v5.66H9.36V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0Z" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className || $[2] !== size) {
    t3 = <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" className={className} aria-hidden={true}>{t2}</svg>;
    $[1] = className;
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function XIcon(t0) {
  const $ = _c(4);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M18.244 2H21.5l-7.5 8.572L23 22h-6.78l-5.31-6.81L4.8 22H1.54l8.02-9.166L1 2h6.91l4.81 6.358L18.244 2Zm-2.38 18h1.873L7.21 4H5.2l10.664 16Z" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className || $[2] !== size) {
    t3 = <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" className={className} aria-hidden={true}>{t2}</svg>;
    $[1] = className;
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function InstagramIcon(t0) {
  const $ = _c(6);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect x="3" y="3" width="18" height="18" rx="5" />;
    t3 = <circle cx="12" cy="12" r="4" />;
    t4 = <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== size) {
    t5 = <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden={true}>{t2}{t3}{t4}</svg>;
    $[3] = className;
    $[4] = size;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function MailIcon(t0) {
  const $ = _c(5);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect x="3" y="5" width="18" height="14" rx="2.5" />;
    t3 = <path d="m3 7 9 6 9-6" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== className || $[3] !== size) {
    t4 = <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden={true}>{t2}{t3}</svg>;
    $[2] = className;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
const SOCIAL_ICON: Record<string, (p: IconProps) => React.ReactElement> = {
  github: GithubIcon,
  linkedin: LinkedinIcon,
  twitter: XIcon,
  instagram: InstagramIcon,
  email: MailIcon
};
const INSIGHTS_LINKS = [{
  label: "Case Study",
  href: "/portfolio"
}, {
  label: "Careers",
  href: "/careers"
}, {
  label: "Testimonials",
  href: "/#testimonials"
}, {
  label: "Life At Cybitix",
  href: "/about"
}];
const SERVICES_LINKS = [{
  label: "Mobile App Development",
  href: "/services/web-mobile"
}, {
  label: "Web App Development",
  href: "/services/web-mobile"
}, {
  label: "AI Based Solution",
  href: "/services/ai-enablement"
}, {
  label: "IoT Based Solution",
  href: "/services/custom-platforms"
}, {
  label: "AI Agents",
  href: "/services/ai-agents"
}];
const OFFICE = {
  title: "Our Office",
  lines: ["Office No. 147 Basement, Center Point, Kohinoor,", "Faisalabad, Pakistan - 38000"],
  whatsapp: "+92 (327) 87 50005",
  landline: "+92 (41) 87 50005"
};
const CONTACT_EMAIL = "info@cybitix.com";
export default function Footer() {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().getFullYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentYear = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div aria-hidden={true} className="absolute inset-0 -z-10" style={{
      background: "radial-gradient(600px 360px at 8% 0%, rgba(11, 201, 240, 0.06), transparent 60%), radial-gradient(700px 460px at 92% 100%, rgba(42, 125, 255, 0.08), transparent 60%), linear-gradient(180deg, #050818 0%, #03050f 55%, #020409 100%)"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden={true} className="absolute inset-0 -z-10 opacity-[0.06] mix-blend-screen" style={{
      backgroundImage: "radial-gradient(rgba(255,255,255,0.5) 1px, transparent 1px)",
      backgroundSize: "26px 26px"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src="/images/cybitix-solution-logo.png" alt="Cybitix" width={180} height={56} className="h-auto w-[180px]" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mx-auto grid w-full max-w-7xl gap-10 px-6 py-14 sm:gap-12 md:grid-cols-2 md:py-16 lg:grid-cols-[1.4fr_1fr_1fr]"><div className="space-y-7 md:col-span-2 lg:col-span-1">{t3}<div className="space-y-4"><p className="text-base font-bold tracking-tight text-(--text)">Newsletter</p><FooterNewsletter /></div></div><FooterColumn title="Insights" links={INSIGHTS_LINKS} /><FooterColumn title="Services" links={SERVICES_LINKS} /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <a href={`mailto:${CONTACT_EMAIL}`} className="group relative inline-block text-base font-semibold text-(--text)"><span className="relative z-10">{CONTACT_EMAIL}</span><span className="absolute -bottom-0.5 left-0 h-px w-full bg-(--stroke)" /><span className="absolute -bottom-0.5 left-0 h-px w-0 bg-(--accent) transition-[width] duration-300 ease-out group-hover:w-full" /></a>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-lg font-bold tracking-tight text-(--accent)">Follow us</p>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="space-y-7">{t5}<div className="space-y-3">{t6}<div className="flex flex-wrap gap-3">{FOOTER_SOCIAL_LINKS.map(_temp)}</div></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="text-lg font-bold tracking-tight text-(--accent)">{OFFICE.title}</p>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <address className="not-italic text-sm leading-relaxed text-(--muted)">{OFFICE.lines.map(_temp2)}</address>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="text-(--text)">Whatsapp:</span>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p>{t10}{" "}<a href={`https://wa.me/${OFFICE.whatsapp.replace(/[^\d]/g, "")}`} target="_blank" rel="noopener noreferrer" className="footer-inline-link">{OFFICE.whatsapp}</a></p>;
    t12 = <span className="text-(--text)">Landline:</span>;
    $[11] = t11;
    $[12] = t12;
  } else {
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mx-auto grid w-full max-w-7xl gap-10 px-6 pb-12 sm:gap-12 md:grid-cols-2 md:pb-14 lg:grid-cols-[1.4fr_2fr]">{t7}<div className="space-y-4">{t8}{t9}<div className="space-y-1 text-sm text-(--muted)">{t11}<p>{t12}{" "}<a href={`tel:${OFFICE.landline.replace(/[^\d+]/g, "")}`} className="footer-inline-link">{OFFICE.landline}</a></p></div></div></div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span>© {currentYear} Cybitix Solutions, All Rights Reserved.</span>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <footer className="relative bg-[#040a2e]/70 overflow-hidden border-t border-white/5 text-(--text)">{t1}{t2}{t4}{t13}<div className="border-t border-white/5"><div className="mx-auto flex w-full max-w-7xl flex-col items-start justify-between gap-3 px-6 py-5 text-xs text-(--subtle) sm:flex-row sm:items-center">{t14}<div className="flex flex-wrap items-center gap-x-6 gap-y-2"><Link href="/privacy-policy" className="footer-inline-link">Privacy Policy</Link><Link href="/terms-of-service" className="footer-inline-link">Terms of Service</Link></div></div></div></footer>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  return t15;
}
function _temp2(line) {
  return <span key={line} className="block">{line}</span>;
}
function _temp(link) {
  const Icon = SOCIAL_ICON[link.icon] ?? MailIcon;
  return <a key={link.icon} href={link.href} target={link.icon !== "email" ? "_blank" : undefined} rel="noopener noreferrer" aria-label={link.label} className="group flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-white/[0.03] text-(--muted) transition-all duration-200 hover:-translate-y-0.5 hover:border-(--accent) hover:bg-(--accent)/10 hover:text-(--accent) hover:shadow-[0_8px_22px_-10px_rgba(11,201,240,0.65)]"><Icon size={16} className="transition-transform duration-200 group-hover:scale-110" /></a>;
}
interface FooterColumnProps {
  title: string;
  links: {
    label: string;
    href: string;
  }[];
}
function FooterColumn(t0) {
  const $ = _c(9);
  const {
    title,
    links
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="text-lg font-bold tracking-tight text-(--accent)">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== links) {
    t2 = links.map(_temp3);
    $[2] = links;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <ul className="space-y-3">{t2}</ul>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className="space-y-5">{t1}{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp3(link) {
  return <li key={link.label}><Link href={link.href} className="footer-link"><span className="footer-link-dot" aria-hidden={true} /><span className="footer-link-label">{link.label}</span></Link></li>;
}